export default "__VITE_ASSET__DZSoao74__"